import React from "react";
import { StepContentProps } from "./BusinessInfoTypes";
import { DynamicArraySection } from "./DynamicArraySection";
import { FormTextField } from "./FormTextField";
import { ControlledFileInput } from "./ControlledFileInput";
import { Project } from "./BusinessInfoTypes";

/**
 * Step 2: Past Projects (Simple Controlled Form)
 */
export const StepProjects: React.FC<StepContentProps> = ({
  formData,
  setFormData,
}) => {
  return (
    <div>
      <DynamicArraySection<Project>
        title="2. Past Projects"
        items={formData.projects}
        setItems={(projects) =>
          setFormData((prev) => ({
            ...prev,
            projects,
          }))
        }
        itemTitle={(index) => `Project ${index}`}
        createItem={() => ({
          id: crypto.randomUUID(),
          name: "",
          description: "",
           files: [],
        })}
        renderItem={(item, index, updateItem) => (
          <div className="space-y-3 ">
            <FormTextField
              label="Project Title (Optional)"
              value={item.name}
              onChange={(value) =>
                updateItem({
                  ...item,
                  name: value,
                })
              }
            />

            {/* Project Description */}
            <FormTextField
              label="Project Summary (Optional)"
              value={item.description ?? ""}
              multiline
              rows={2}
              onChange={(value) =>
                updateItem({
                  ...item,
                  description: value,
                })
              }
            />

            {/* Project Files */}
           <ControlledFileInput
             label="Upload Project Files"
             multiple
             value={item.files} // string[]
             folderPath="/Business_info/past_projects"
             onChange={(urls) =>
             updateItem({
              ...item,
              files: urls,
            })
  }
/>

            {/* {formData.projects.length > 1 && (
            <button
              type="button"
              onClick={() => removeItem(index)}
              className="text-red-600 text-sm"
            >
              Remove project
            </button>
          )} */}
          </div>
        )}
      />
    </div>
  );
};
